import { Placement, TooltipTargetRect } from './Tooltip.types';

const MINIMUM_VIEW_PORT_POSITIONING = 8;

const TARGET_SPACING = 2;

export const getTooltipPosition = (
  targetRect: TooltipTargetRect,
  tooltip: HTMLElement,
  placement: Placement,
): { top: number; left: number } => {
  const tooltipRect = tooltip.getBoundingClientRect();

  let top = 0;
  let left = 0;

  switch (placement) {
    case 'top-left':
      top = targetRect.top - tooltipRect.height - TARGET_SPACING;
      left = targetRect.left;
      break;
    case 'top':
      top = targetRect.top - tooltipRect.height - TARGET_SPACING;
      left = targetRect.left + targetRect.width / 2 - tooltipRect.width / 2;
      break;
    case 'top-right':
      top = targetRect.top - tooltipRect.height - TARGET_SPACING;
      left = targetRect.right - tooltipRect.width;
      break;
    case 'bottom-left':
      top = targetRect.bottom + TARGET_SPACING;
      left = targetRect.left;
      break;
    case 'bottom':
      top = targetRect.bottom + TARGET_SPACING;
      left = targetRect.left + targetRect.width / 2 - tooltipRect.width / 2;
      break;
    case 'bottom-right':
      top = targetRect.bottom + TARGET_SPACING;
      left = targetRect.right - tooltipRect.width;
      break;
    case 'left-top':
      top = targetRect.top;
      left = targetRect.left - tooltipRect.width - TARGET_SPACING;
      break;
    case 'left':
      top = targetRect.top + targetRect.height / 2 - tooltipRect.height / 2;
      left = targetRect.left - tooltipRect.width - TARGET_SPACING;
      break;
    case 'left-bottom':
      top = targetRect.bottom - tooltipRect.height;
      left = targetRect.left - tooltipRect.width - TARGET_SPACING;
      break;
    case 'right-top':
      top = targetRect.top;
      left = targetRect.right + TARGET_SPACING;
      break;
    case 'right':
      top = targetRect.top + targetRect.height / 2 - tooltipRect.height / 2;
      left = targetRect.right + TARGET_SPACING;
      break;
    case 'right-bottom':
      top = targetRect.bottom - tooltipRect.height;
      left = targetRect.right + TARGET_SPACING;
      break;
  }

  if (left < MINIMUM_VIEW_PORT_POSITIONING) {
    left = MINIMUM_VIEW_PORT_POSITIONING;
  } else if (left + tooltipRect.width > window.innerWidth - MINIMUM_VIEW_PORT_POSITIONING) {
    left = window.innerWidth - tooltipRect.width - MINIMUM_VIEW_PORT_POSITIONING;
  }

  if (top < MINIMUM_VIEW_PORT_POSITIONING) {
    top = MINIMUM_VIEW_PORT_POSITIONING;
  } else if (top + tooltipRect.height > window.innerHeight - MINIMUM_VIEW_PORT_POSITIONING) {
    top = window.innerHeight - tooltipRect.height - MINIMUM_VIEW_PORT_POSITIONING;
  }
  return { top, left };
};
